import { Component, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { PopupNotification } from '../../models/notification/notificationRole.model';
import { NotificationService } from '../../services/notification/notification.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoryService } from '../../services/category/category.service';
@Component({
    selector: 'app-popup-notification-list',
    templateUrl: './popup-notification-list.component.html',
    styleUrls: ['./popup-notification-list.component.css']
})
/** popup-notification-list component*/
export class PopupNotificationListComponent {
    /** popup-notification-list ctor */
  public popupNotificationList: PopupNotification[];
  public searchKeyword: string;
  public websiteName: string;
  // paged items
  filteredItems: any[];
  isActive: string;
  pager: any = {};
  pageSize: number;
  pagedItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService, private readonly categoryService: CategoryService,
    private readonly utilitiesService: UtilitiesService, private readonly notificationService: NotificationService) {
    this.rolePermissionService.GetRolePermissions("notification").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            //this.GetSystemSettingFirstOrDefault();
            this.pageSize = 10;
            this.GetPopupNotificationList();
            //   this.GetBlogStatus();
            this.GetRowsPerPageList();
            this.isActive = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      });
    }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        if (data)
          this.websiteName = data.siteUrl + "/popupNotification/";
      });
  }
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  GetPopupNotificationList() {
    this.notificationService.GetPopupNotifications().subscribe(
      data => {
        this.popupNotificationList = data;

        this.filteredItems = data;
      }
    )
  }
  deletePopupNotification(id) {
    if (confirm("Are you sure to delete this PopupNotification ?")) {
      this.notificationService.DeletePopupNotification(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Popup Notification has been Deleted.', 'Success');
            setTimeout(() => {
              this.GetPopupNotificationList();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Success');
          }
        }
      )
    }
  }
  OnFilterChange() {
    this.filteredItems = this.popupNotificationList;
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/notification-components/popup-notification-list/popup-notification-list.component.ts